import * as Yup from "yup";
import RouteCityModel from "../../models/masters/routecity-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetRouteCity } from "../../apiclient/master/useGetRouteCityApi";

interface RouteCityEditProps {
  data: RouteCityModel;
  isViewMode?: boolean;
  onClose?: (status: SubmitStatus, data: any) => any;
}

const RouteCityEntry: React.FC<RouteCityEditProps> = ({ ...props }) => {
  let { data,  onClose,isViewMode } = props;
  const title = data?.routeCityId > 0 ? "Edit Route City" : "Add Route City";
  
  let initialValue: RouteCityModel = {
    routeCityId: data?.routeCityId? data.routeCityId:0,
    name: data?.name,
    displayOrder: data?.displayOrder,
   
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "RouteCity name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 
    displayOrder: Yup.string().required("Required"),
  });

  
  const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
  const { data: fetchedRouteCity } = useGetRouteCity(); // Fetching existing zones data

  useEffect(() => {
      if (fetchedRouteCity) {
          setExistingName(fetchedRouteCity.map((zone: any) => zone.name)); // Extracting zone names to compare against
      }
  }, [fetchedRouteCity]);
  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="RouteCity/SaveRouteCity"
        showAddAnother={true}
        isUpDateEntityDetails={data?.routeCityId>0? true: false}
        isViewOnly ={isViewMode}
      >
        <div>
          <div className="row">
            <div className="col-4">
              <InputField maxLength={100} label="Route City *" name="name" />
            </div>
            
            <div className="col-6">
              
                  <InputField
                    maxLength={50}
                    label="Display Order *"
                    name="displayOrder"
                  />
                </div>
                
              
            </div>
          </div>
        
      </FormikModelDialog>
    </>
  );
};

export default RouteCityEntry;
